'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Gauge } from 'lucide-react';
import {
  NestedSheet,
  NestedSheetContent,
  NestedSheetHeader,
  NestedSheetTitle,
  NestedSheetBody,
} from '@/shared/ui';
import {
  EffortContent,
  getEffortSubtitle,
} from '../settings-content/EffortContent';
import type { RenderEffort } from '@/types/render';
import { SettingsSectionRow } from './SettingsSection';

interface EffortSectionProps {
  selectedEffort: RenderEffort;
  onEffortChange: (effort: RenderEffort) => void;
  hasChanges?: boolean;
}

export function EffortSection({
  selectedEffort,
  onEffortChange,
  hasChanges = false,
}: EffortSectionProps) {
  const t = useTranslations('render.settings.effort');
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  const subtitle = getEffortSubtitle(selectedEffort, t);

  return (
    <>
      <SettingsSectionRow
        icon={Gauge}
        title={t('title')}
        subtitle={subtitle}
        hasChanges={hasChanges}
        onClick={() => setIsSheetOpen(true)}
      />

      <NestedSheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
        <NestedSheetContent>
          <NestedSheetHeader>
            <NestedSheetTitle>{t('title')}</NestedSheetTitle>
          </NestedSheetHeader>

          <NestedSheetBody className="px-4">
            <EffortContent
              selectedEffort={selectedEffort}
              onEffortChange={onEffortChange}
              variant="compact"
              closeOnSelect={() => setIsSheetOpen(false)}
            />
          </NestedSheetBody>
        </NestedSheetContent>
      </NestedSheet>
    </>
  );
}
